import React from 'react';
import './stepper.css'

const Stepper = ({ currentStep = 0, steps = [] }) => {
  return (
    <div className="arrow-stepper">
      {steps.map((step, index) => (
        <React.Fragment key={index}>
          <div className="step-item">
            <div
              className={`step-circle ${index === currentStep
                  ? 'active'
                  : index < currentStep
                    ? 'completed'
                    : 'inactive'
                }`}
            >
              {index + 1}
            </div>
            <div
              className={`step-label ${index === currentStep
                  ? 'active'
                  : index < currentStep
                    ? 'completed'
                    : 'inactive'
                }`}
            >
              {step.label}
            </div>
          </div>
          {index !== steps.length - 1 && (
            <div className="step-arrow">
              <i className="bi bi-chevron-right"></i>
            </div>
          )}
        </React.Fragment>
      ))}
    </div>
  );
};

export default Stepper;
